export default __webpack_public_path__ + "static/media/desktop_banner_contact.c33e6f04.jpg";